export default __webpack_public_path__ + "static/media/7.fd3e6ee2.png";